import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '@Components/Common/Modal';
import TX from '@Components/Common/Text';
import { ReactComponent as DeleteSVG } from '@Assets/Svgs/ic_delete.svg';
import { useSelector, useDispatch } from 'react-redux';
import { useModal, hideModal } from '@Services/Modal';
import { MODAL_TYPES } from '@Services/Modal/Constants';
import { addMoveProcessHighLight, moveProcess, resetHilightProcess } from '@Services/Editor';

const PageMoveModal = ({ processes, snackBarRef, scrollToTargetProcess, setPage }) => {
  const modal = useSelector(useModal);
  const dispatch = useDispatch();
  const [targetPageId, setTargetPageId] = useState('');

  const closeModal = () => {
    dispatch(hideModal(MODAL_TYPES.PAGE_MOVE));
    setTargetPageId('');
  };

  const onChangeFunc = e => {
    const { value } = e.target;
    if (/^\d*$/.test(value)) {
      setTargetPageId(value);
    }
  };

  const movePageFunc = () => {
    const {
      modalProps: { currentProcessId },
    } = modal;

    // console.log('currentProcessId:', currentProcessId);
    // console.log('targetPageId:', targetPageId);

    // const findCurrentProcessId = processes.findIndex(process => process.processId === currentProcessId);
    const findTargetPageIdProcess = processes.find(process => process.processId === Number(targetPageId));

    if (!findTargetPageIdProcess) {
      snackBarRef.current.show({
        text: '해당 페이지가 존재하지 않습니다.',
      });
      return;
    }

    if (targetPageId === '') {
      snackBarRef.current.show({
        text: '이동할 페이지를 입력해주세요.',
      });
      return;
    }

    if (Number(targetPageId) === currentProcessId) {
      snackBarRef.current.show({
        text: '현재 페이지와 같은 페이지로 이동할 수 없습니다.',
      });
      return;
    }

    if (findTargetPageIdProcess) {
      dispatch(moveProcess({ currentProcessId, targetPageId: Number(targetPageId) }));
      closeModal();

      const groupNumber = Math.floor(findTargetPageIdProcess.processId / 20) + 1;

      setPage(groupNumber);

      setTimeout(() => {
        scrollToTargetProcess(targetPageId);

        dispatch(addMoveProcessHighLight({ processId: Number(targetPageId) }));

        setTimeout(() => {
          dispatch(resetHilightProcess());
        }, 1000); // 1초 후에 resetHilightProcess 액션 디스패치
      }, 500); // 500 밀리초 = 0.5초

      // setTimeout(() => {
      //   scrollToTargetProcess(targetPageId);
      // }, 500); // 500 밀리초 = 0.5초
    }
  };

  return (
    <Modal isShowCloseButton={false} visible={modal?.isVisible} handleCloseButtonClick={closeModal}>
      <ModalContentContainer>
        <Header>
          <CloseIconWrapper onClick={closeModal}>
            <CloseIcon />
          </CloseIconWrapper>
        </Header>

        <InfoText>
          페이지 이동시 원래 페이지는 뒤로 한 칸 이동합니다.
          <br />
          예) 7페이지를 4페이지로 이동하는 경우, 기존 4페이지는 5페이지, 5페이지는 6페이지가 됨
        </InfoText>

        <Footer>
          <Dummy />

          <MovePageInput
            // eslint-disable-next-line no-unsafe-optional-chaining
            placeholder={`이동할 페이지(0 ~ ${processes?.length && processes?.length ? processes?.length - 1 : 0})`}
            page={targetPageId}
            value={targetPageId}
            onChange={onChangeFunc}
          />
          <MoveButton onClick={movePageFunc}>
            <MobeText>이동</MobeText>
          </MoveButton>
        </Footer>
      </ModalContentContainer>
    </Modal>
  );
};

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  /* height: 96px; */

  /* margin-bottom: 16px; */
`;

const Header = styled.div`
  display: flex;
  /* width: 360px; */
  padding: 0px 10px 6px 318px;
  justify-content: flex-end;
  align-items: center;
`;

const CloseIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  justify-content: center;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const CloseIcon = styled(DeleteSVG)`
  width: 16px;
  height: 16px;

  stroke: ${({ theme }) => theme.colors.ui_on_3};
`;

const InfoText = styled(TX.BodyM)`
  color: '#383839';
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;

  /* BodyM */
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 160% */
  margin: 16px 0px;
`;

const Footer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

const Dummy = styled.div`
  display: flex;
  height: 32px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const MovePageInput = styled.input`
  width: 203px;
  height: 32px;
  border-radius: 5px;
  border: 1px solid var(--ui_on_5, #acacad);
  padding-left: 10px;

  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 160% */
  opacity: 1;

  ${({ page }) =>
    !page &&
    `
    color:red
font-style: normal;
font-weight: 500;
line-height: 24px; /* 160% */
opacity: 0.3;


  `}
`;

const MoveButton = styled.button`
  display: flex;
  height: 32px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background: var(--Primary, #674af6);
  border: none;
  cursor: pointer;
`;

const MobeText = styled.text`
  color: var(--ui_1, #fcfcfd);

  /* FootnoteM */
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 123.077% */
  letter-spacing: -0.3px;
`;
export default PageMoveModal;
